<template>
    <div class="maya-app-header" :class="{'opacity': opacity}">
        <div class="header">
            <!-- <div class="left" @click="leftClickHandler" :class="{'comeback_left':!comeBack}">
                <van-icon :name="$i18n.locale ==='ar-AE' ? 'arrow' : 'arrow-left'"  v-if="comeBack" />
                <span v-if="title && !Module_SearchRegion" class="title">{{ title }}</span>
            </div> -->
            <div>
                <van-icon class="header-back" @click="leftClickHandler" :name="$i18n.locale ==='ar-AE' ? 'arrow' : 'arrow-left'"  v-if="comeBack" />
            </div>
            <div class="">
                <span class="header-title">{{title}}</span>
            </div>
            <!-- <div class="select-country" @click="goSelectCountryPage" v-if="Module_SearchRegion" >
                <input />
                <div class="select-placeholder">{{ $t('home.input_placeholder') }}</div>
            </div> -->
        </div>
        <!-- <div class="title-bottom" v-if="title &&　Module_SearchRegion">{{title}}</div> -->
    </div>
</template>

<script>
    import checkProjectConfig from '@/lib/checkProjectConfig';
    export default {
        name: 'AppHomeHeader',
        props: {
            title: {
                type: String,
                default: ''
            },
            opacity: {
                type: Boolean,
                default: false
            },
            comeBack:{
                type: Boolean,
                default: true
            }
        },
         computed: {
            Module_SearchRegion:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_SearchRegion",true);
            }
        },
        methods: {
            leftClickHandler() {
                this.$nextTick(() => {
                    this.$emit('on-click');
                });
            },
            goSelectCountryPage() {            
                this.$router.push({
                    name: 'RegionList'
                });
            }            
        }
    }
</script>

<style lang="less" scoped>
    .maya-app-header {
        position: relative;
        z-index: 10;
        background-color: #fff;
        &.opacity {
            background: transparent;
            .van-icon-arrow-left {
                color: #fff;
            }
        }
        .header {                    
            position: relative;
            height: 48px;
            display: flex;
            align-items: center;
            padding-left: 16px;   
            .header-back {
                font-size: 22px;
            }         
            .header-title {
                font-size: 14px;
            }            
            .left {                            
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;                
                font-size: 14px;     
                padding-left: 35px;
                padding-right: 10px;           
                .van-icon-arrow-left {
                    font-size: 22px;
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .title {
                    line-height: 49px;
                    overflow: hidden;
                    display: inline-block;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    width: 180px;
                }
            }
            .comeback_left {
                padding: 0 10px 0 16px; 
            }
            .select-country {
                height: 40px;
                width: 284px;
                position: absolute;
                right: 16px;
                top: 50%;
                transform: translateY(-50%);
                input {
                    background: #F5F5F5;
                    border-radius: 20px;
                    border: none;
                    width: 100%;
                    height: 100%;
                    text-align: center;
                }
                .select-placeholder {
                    white-space:nowrap;
                    opacity: 0.7;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #909090;
                    letter-spacing: 0;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    padding-left: 22px;
                    background: url('../../../assets/imgs/home/search-icon.png') no-repeat left center / 12px;
                }
            }            
        }
        .title-bottom {
            text-align: center;
            padding-top: 8px;
            font-size: 14px;
            background-color: #f2f2f2;
            position: relative;
            bottom: -6px;
            border-bottom: 2px solid #f2f2f2;
        }
    }

    html[dir="rtl"] .maya-app-header { 
        .header { 
            padding-left: unset;
            padding-right: 16px;
            .left {                   
                left: unset;
                right: 0;
                padding-left: 10px;
                padding-right: 35px; 
                .van-icon-arrow {
                    font-size: 22px;
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .select-country { 
                right: unset;
                left: 16px;
                .select-placeholder {
                    padding-left: unset;
                    padding-right: 22px;
                    background: url('../../../assets/imgs/home/search-icon.png') no-repeat right center / 12px;
                }
            }
        }
    }
</style>